import React from 'react';
import { connect } from 'react-redux';

import {
  PriceBlockProps,
  PriceBlockStateProps
} from '../../types/components/collections/PriceBlock';
import { ApplicationState } from '../../types/state/storeTypes';
import { User } from '../../types/api/UsersTypes';
import { SubscriptionDetail } from '../../types/api/SubscriptionTypes';

import PurchaseButton from '../products/PurchaseButton';
import PriceElement from '../pricing/PriceElement';
import { FreeProductMarker } from '../shared/FreeProductMarker';
import LegacyCreditsPurchaseBlock from './LegacyCreditsPurchaseBlock';

import { usePricingLogic } from '../../hooks/usePricingLogic';

const PriceBlock: React.FC<PriceBlockProps> = (props) => {
  const { purchasedItem, className, onPurchased, onOwnershipDataLoaded, user, subscription, mode, totalCreditPrice } = props;

  const {
    handlePurchase,
    isPricingVisible,
    isLegacyCredit,
    isFreeProduct
  } = usePricingLogic({
    item: purchasedItem,
    onPurchased: () => onPurchased(),
    onOwnershipDataLoaded: (ownership: any) => onOwnershipDataLoaded(ownership),
    user,
    subscription
  });

  const isPurchaseOptionsMode = mode === 'purchase-options-modal';

  return (
    <div className={`w-full ${className || ''}`} cy-test-id="price-block">
      {isFreeProduct && (
        <div className="pb-8">
          <h4 className="pb-6 font-bold text-[#24C1FF] text-[32px] inter">
            FREE
          </h4>
          <FreeProductMarker user={user} />
        </div>
      )}

      {!isLegacyCredit ? (
        <>
          {isPurchaseOptionsMode || isPricingVisible() && (
            <PriceElement
              purchasedItem={purchasedItem}
              className="mb-[20px]"
              showSavingsBadge={true}
              user={user}
            />
          )}
          {isPurchaseOptionsMode || !purchasedItem.free_for_member && <PurchaseButton
            mode="collection-page"
            className="w-full"
            purchasedItem={purchasedItem}
            onPurchased={handlePurchase}
            totalCreditPrice={totalCreditPrice}
            collectionId={purchasedItem.id}
          />}
        </>
      ) : (
        <LegacyCreditsPurchaseBlock
          collection={purchasedItem}
          subscription={subscription}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: ApplicationState): PriceBlockStateProps => ({
  user: state.auth.user as User,
  subscription: state.auth.subscription as SubscriptionDetail
});

export default connect(mapStateToProps)(PriceBlock);
